import { get, post, upload } from '@/utils/request'

export const getSlides = (id = 1) => post('/api/index/slide', { id })

export const getModuleList = () => get('/api/home_module/moduleList')

export const getExpertList = (params = {}) => {
  const { page = 1, limit = 20, keywords = '' } = params
  return post('/api/expert/expertList', { page, limit, keywords })
}

export const getExpertDetail = (id) => get('/api/expert/expertDetail', { id })

export const getRecycleConfig = () => get('/api/recycle/recycleConfig')

export const submitRecycleMessage = (data) =>
  post('/api/recycle/submitMessage', data, {
    showLoading: true,
    loadingText: '提交中...'
  })

export const uploadFile = (file) => upload(file)

export const getResearchList = (params = {}) => {
  const { page = 1, limit = 20, title = '' } = params
  return post('/api/research/researchList', { page, limit, title })
}

export const getResearchDetail = (id) => get('/api/research/researchDetail', { id })

export const getContactInfo = () => get('/api/contact/info')
